import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'app-page500',
    templateUrl: './page500.component.html',
    styleUrls: ['./page500.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class Page500Component {

  constructor() { }

}
